import {Box, CircularProgress, Typography, Container} from '@mui/material';
import React, {useContext, useEffect, useState} from 'react';

import {getCollages} from '../../http/clinicServiceAPI';
import {Context} from "../..";
import CollageItem from './CollageItem';

const CollageService = () => {
    const [collages, setCollages] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state
    const {user} = useContext(Context);

    useEffect(() => {
        setLoading(true); // Set loading to true before fetching
        getCollages(user.user.clinicId)
            .then((data) => {
                setCollages(data.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1)));
            })
            .catch((error) => {
                console.error('Error fetching collages:', error); // Basic error logging
            })
            .finally(() => {
                setLoading(false); // Set loading to false after fetch completes
            });
    }, [user.user.clinicId]);

    return (
        <Container disableGutters sx={{ px: 0 }}>
            {loading ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '200px', // Ensure loading spinner is centered vertically
                    }}
                >
                    <CircularProgress/>
                </Box>
            ) : (
                <Container
                    disableGutters={true}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        gap: 2,
                        p: 0,
                    }}
                >
                    {collages.length > 0 ? (
                        collages.map((collage) => (
                            <CollageItem key={collage.id} collage={collage}/>
                        ))
                    ) : (
                        <Box sx={{textAlign: 'center', py: 2}}>
                            <Typography variant="body1" color="textSecondary">
                                Нет коллажей для отображения
                            </Typography>
                        </Box>
                    )}
                </Container>
            )}
        </Container>
    );
};


export default CollageService;
